/* import __COLOCATED_TEMPLATE__ from './tie-order-text-field.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class TieOrderTextFieldComponent extends Component 
{
	@service store;
	
	@action
	async save(browserEvent)
	{
		var newOrder = browserEvent.target.value;
		var resultId = this.args.result.id;
		var eventId = this.args.result.EventId;
		
		const entry = await this.store.findRecord('Entry', resultId);
		
		let tieTimingRecord = await entry.get('TieTimingRecordId');
		
		if(tieTimingRecord == null)
		{
			const event = await this.store.findRecord('Event',eventId);
			
			tieTimingRecord = this.store.createRecord('TieTimingRecord',
			{
				EntryId: entry,
				EventId: event,
				order: newOrder
			});
		}
		else
		{
			if(newOrder == "")
			{
				tieTimingRecord.deleteRecord();
			}
			else
			{
				tieTimingRecord.order = newOrder;
			}
		}
		
		try
		{
			await tieTimingRecord.save();
		}
		catch (error)
		{
			alert(error);
		}
	}
}

